import { useQuery } from '@tanstack/react-query';
import {
  fetchMinerCollateral,
  MinerCollateralUnavailableError,
  type CollateralData,
} from '../lib/minerApi.js';

export function useMinerCollateral(
  address: string | null,
  enabled = true,
) {
  return useQuery<CollateralData | null>({
    queryKey: ['miner-collateral', address],
    queryFn: async () => {
      if (!address) return null;
      try {
        return await fetchMinerCollateral(address);
      } catch (err) {
        if (err instanceof MinerCollateralUnavailableError) return null;
        if (err instanceof Error && err.message.includes('404')) return null;
        throw err;
      }
    },
    enabled: !!address && enabled,
    staleTime: 60_000,
    retry: 1,
  });
}
